import React from "react";
import { Link } from "react-router-dom";
import { Api } from "../app-controller.js";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";

class ProductIventory extends React.Component {
  initialState = {
    previa: false,
    previa_url: "",
    modalState: false,
    working: true,
    workingModal: true,
    observationModalOpen: false,
    toggle: false,
    paginaActual: 0,
    nivelUsuario: localStorage.nivel_actual,
    bitacora_movimiento: "",
    paginaActual_vi: 0,
    paginas: 0,
    paginas_vi: 0,
    registros: 0,
    registros_vi: 0,
    productos: [],
    activeTab: "1",
    buscar: {},
    cat_actividad: Api.loadCatalogue("cat_actividad"),
    collapse: [
      {
        id: 1,
        collapse: true,
      },
      {
        id: 2,
        collapse: false,
      },
    ],
  };

  constructor(props) {
    super(props);

    this.state = this.initialState;
  }

  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  };

  toggleCollapse = (index) => {
    var newArray = [];
    for (let collapseObj of this.state.collapse) {
      if (collapseObj.id === index) {
        collapseObj.collapse = !collapseObj.collapse;
      } else {
        collapseObj.collapse = false;
      }
      newArray.push(collapseObj);
    }

    this.setState({ collapse: newArray });
  };

  componentDidMount() {
    // si el usuario no es nivel drycip redireccionamos a home
    if (!["1", "3"].includes(this.state.nivelUsuario)) {
      window.location.href = "/";
    }

    this.setState({ buscar: this.search });
    this.getProductsInventory(1);
  }

  // Inicia logica que controla la pestaña de regente (grid y detalle)
  search = [];

  handleSearch = (evt) => {
    // Si el obj.target.name pertenece a un input type text aplicamos la funcion toUpperCase()
    [
      "producto",
      "empaque",
      "lote",
      "cantidad",
      "fabricante",
      "fecha_fabricacion",
      "vencimiento_lote",
      "establecimiento",
    ].includes(evt.target.name)
      ? (this.search[evt.target.name] = evt.target.value.toUpperCase())
      : (this.search[evt.target.name] = evt.target.value);

    this.setState({ buscar: this.search });
  };

  // cleanSearch = () => {
  //   let search = this.state.buscar;

  //   for (const prop in search) {
  //     delete search[prop];
  //     document.getElementById(prop).value = "";
  //   }

  //   this.setState({ buscar: search });
  //   this.getProductsInventory(1);
  // };

  //Funcion para cambiar de pagina en el grid de regente
  getProductsInventory = (page) => {
    this.setState({ workingGrid: true });
    let search = this.state.buscar;
    let src = "";

    search["nivel_usuario"] = this.state.nivelUsuario;

    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getProductsInventory?page=" + page + src).then((prod) => {
      this.setState({
        productos: prod.data,
        paginas: prod.last_page,
        registros: prod.total,
        paginaActual: prod.current_page,
        workingGrid: false,
      });
    });
  };

  handleProductInventoryPage = (e) => {
    this.getProductsInventory(e.target.value);
  };

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Inicio</Link>
          </li>
          <li className="breadcrumb-item">Inventario</li>
        </ol>
        <h1 className="page-header">Inventario</h1>
        <div className="row">
          <div className="col-xl-12">
            <Nav tabs={true}>
              <NavItem>
                <NavLink
                  className={classnames({
                    active: this.state.activeTab === "1",
                  })}
                  onClick={() => {
                    this.toggleTab("1");
                  }}
                >
                  <span className="d-sm-none">
                    PRODUCTOS
                    <span className="label label-success m-l-5 t-minus-1">
                      {this.state.registros}
                    </span>
                  </span>
                  <span className="d-sm-block d-none">
                    PRODUCTOS
                    <span className="label label-success m-l-5 t-minus-1">
                      {this.state.registros}
                    </span>
                  </span>
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId="1">
                <div className="table-responsive">
                  <fieldset>
                    <legend>Buscar</legend>

                    <div className="row">
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label htmlFor="producto">Producto:</label>
                          <input
                            id="producto"
                            name="producto"
                            placeholder="Ingrese producto"
                            onChange={this.handleSearch}
                            className="form-control"
                            type="text"
                          />
                        </div>
                      </div>

{/*                       <div className="col-lg-3">
                        <div className="form-group">
                          <label htmlFor="empaque">Empaque:</label>
                          <input
                            id="empaque"
                            name="empaque"
                            placeholder="Ingrese empaque"
                            onChange={this.handleSearch}
                            className="form-control"
                            type="text"
                          />
                        </div>
                      </div>
 */}
                      <div className="col-lg-4">
                        <div className="form-group">
                          <label htmlFor="lote">Lote:</label>
                          <input
                            id="lote"
                            name="lote"
                            placeholder="Ingrese lote"
                            onChange={this.handleSearch}
                            className="form-control"
                            type="text"
                          />
                        </div>
                      </div>

                      <div className="col-lg-4">
                        <div className="form-group">
                          <label htmlFor="cantidad">Cantidad:</label>
                          <input
                            id="cantidad"
                            name="cantidad"
                            placeholder="Ingrese cantidad"
                            onChange={this.handleSearch}
                            className="form-control"
                            type="number"
                            min={1}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-3">
                        <div className="form-group">
                          <label htmlFor="fabricante">Fabricante:</label>
                          <input
                            id="fabricante"
                            name="fabricante"
                            placeholder="Ingrese fabricante"
                            onChange={this.handleSearch}
                            className="form-control"
                            type="text"
                          />
                        </div>
                      </div>

                      <div className="col-lg-3">
                        <div className="form-group">
                          <label htmlFor="establecimiento">
                            Establecimiento:
                          </label>
                          <input
                            id="establecimiento"
                            name="establecimiento"
                            placeholder="Ingrese establecimiento"
                            onChange={this.handleSearch}
                            className="form-control"
                            type="text"
                          />
                        </div>
                      </div>

                      <div className="col-lg-2">
                        <div className="form-group">
                          <label htmlFor="fecha_fabricacion">
                            Fecha de fabricación:
                          </label>
                          <input
                            type="date"
                            name="fecha_fabricacion"
                            onChange={this.handleSearch}
                            id="fecha_fabricacion"
                            className="form-control"
                            placeholder="Fecha"
                          />
                        </div>
                      </div>

                      <div className="col-lg-2">
                        <div className="form-group">
                          <label htmlFor="vencimiento_lote">
                            Vencimiento lote:
                          </label>
                          <input
                            type="date"
                            name="vencimiento_lote"
                            onChange={this.handleSearch}
                            id="vencimiento_lote"
                            className="form-control"
                            placeholder="Fecha"
                          />
                        </div>
                      </div>

                      <div className="col-lg-2">
                        <div className="form-group">
                          <label htmlFor="search">&nbsp;</label>
                          <button
                            type="button"
                            className="btn btn-orange w-100"
                            title="Buscar"
                            onClick={() => this.getProductsInventory(1)}
                          >
                            <i className="fa fa-search"></i> Buscar
                          </button>
                        </div>
                      </div>

                      {/* <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="search">&nbsp;</label>
                        <div className="input-group">
                          <button
                            type="button"
                            className="btn btn-blue w-100"
                            title="Limpiar"
                            onClick={this.cleanSearch}
                          >
                            <i className="fas fa-trash-alt"></i> Limpiar
                          </button>
                        </div>
                      </div>
                    </div> */}
                    </div>
                  </fieldset>
                  <table className="table table-striped m-b-0 table-hover">
                    <thead>
                      <tr>
                        <th className="text-center">PRODUCTO</th>
                        {/*<th className="text-center">EMPAQUE</th>*/}
                        <th className="text-center">LOTE</th>
                        <th className="text-center">CANTIDAD</th>
                        <th className="text-center">FABRICANTE</th>
                        <th className="text-center">FECHA FABRICACIÓN</th>
                        <th className="text-center">VENCIMIENTO LOTE</th>
                        <th className="text-center">ESTABLECIMIENTO</th>
                        <th className="text-center">ACTIVIDAD</th>
                      </tr>
                    </thead>
                    <tbody className={this.state.workingGrid ? "hide" : ""}>
                      {this.state.productos &&
                      this.state.productos.length > 0 ? (
                        this.state.productos.map((prod) => (
                          <tr key={prod.id}>
                            <td className="text-center">
                              {prod.nombre_comercial}
                            </td>
                            {/*<td className="text-center">
                              {prod.empaque_texto}
                        </td>*/}
                            <td className="text-center">{prod.num_lote}</td>
                            <td className="text-center">{prod.cantidad}</td>
                            <td className="text-center">
                              {prod.fabricante_razon_social}
                            </td>
                            <td className="text-center">
                              {prod.fecha_fabricacion_format}
                            </td>
                            <td className="text-center">
                              {prod.vencimiento_lote_fecha}
                            </td>
                            <td className="text-center">
                              {prod.establecimiento_razon_social}
                            </td>
                            <td className="text-center">
                              {prod.actividad_nombre}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center">
                            No se encontraron resultados
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <div className={this.state.workingGrid ? "m-10" : "hide"}>
                    <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                      CARGANDO INFORMACIÓN
                    </div>
                  </div>
                  <hr />
                  <div className="d-flex align-items-center justify-content-center">
                    <ul className="pagination mb-0">
                      <li className="page-item">
                        <button
                          onClick={() => {
                            this.getProductsInventory(1);
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-double-left"></i>
                        </button>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            if (this.state.paginaActual - 1 > 0) {
                              this.getProductsInventory(
                                this.state.paginaActual - 1
                              );
                            }
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-left"></i>
                        </button>
                      </li>
                      <li className="page-item d-flex align-items-center px-2">
                        <div>
                          Página
                          <strong>
                            {" "}
                            {this.state.paginaActual} de {this.state.paginas}
                          </strong>
                        </div>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            if (
                              this.state.paginas >=
                              this.state.paginaActual + 1
                            ) {
                              this.getProductsInventory(
                                this.state.paginaActual + 1
                              );
                            }
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-right"></i>
                        </button>
                      </li>
                      <li className="page-item">
                        <button
                          onClick={() => {
                            this.getProductsInventory(this.state.paginas);
                          }}
                          className="page-link"
                        >
                          <i className="fa fa-angle-double-right"></i>
                        </button>
                      </li>
                    </ul>
                    <div className="ml-3 mr-1">Página:</div>
                    <div className="width-50 mx-2">
                      <input
                        className="form-control"
                        onChange={this.handleProductInventoryPage}
                        type="number"
                        min="1"
                        max={this.state.paginas}
                        value={this.state.paginaActual}
                      />
                    </div>
                    <div></div>
                  </div>
                </div>
              </TabPane>
            </TabContent>
          </div>
        </div>
      </div>
    );
  }
}

export default ProductIventory;
